<template>
    <section class="flex flex-col text-base">
        <PageHeader>
            <h1 v-if="distributor?.Name">
                {{ distributor.Name }}
                <span
                    v-if="distributor.HeadingLabel"
                    class="font-normal text-gray-500 text-xl ml-4"
                    v-html="distributor.HeadingLabel"></span>
            </h1>
        </PageHeader>
        <div class="container space-y-4">
            <DistributorDetail v-if="distributor" />
            <DistributorManufacturerList v-if="distributor" />
        </div>
    </section>
</template>
<script setup lang="ts">
const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const { data: distributor } = await useApi<DistributorDetails>(`distributors/${route.params.dist}`);
if (!distributor.value) {
    throw createError({ status: 404 });
}

const distPath = distributor.value.VirtualPath;
if (distPath) await router.replace({ params: { dist: distPath } });

const title = computed(() => t("Distributor.DistributorTitle", [distributor.value?.Name]));
const description = computed(() => t("Distributor.MetaDescriptionFormat", [distributor.value?.Name]));

useSeoMeta({ title, ogTitle: title, description, ogDescription: description });

provide(DistributorInjectKey, { distributor });
</script>
